import { Component, Vue } from "vue-facing-decorator";

@Component
export default class TypingIndicator extends Vue {
	get isBotHasAvatar() {
		return this.$store.state.isBotHasAvatar || false;
	}

	get typingType() {
		return this.$store.state.typingType || 0;
	}

	get isUserHasAvatar() {
		return this.$store.state.isUserHasAvatar || false;
	}
}
